import React, { useState } from 'react';
interface BookImageProps {
  className?: string;
  /** Rendered size context; only affects the CSS fallback proportions. */
  emblem?: boolean;
}

/**
 * Renders the generic navy book art from /proof/book-generic-navy.png when it
 * exists, and falls back to a styled CSS book until that asset is added. No
 * Marni branding — this is the neutral hero/transformation book.
 */
export function BookImage({
  className = '',
  emblem = true
}: BookImageProps) {
  const [hasImage, setHasImage] = useState(true);
  if (hasImage) {
    return <img src="/proof/Generic%20Book%20with%20Logo.png" alt="An expert nonfiction book" onError={() => setHasImage(false)} className={`object-contain ${className}`} data-id="element-578" data-mp="2pbf7i275676z" />;
  }
  return <div className={`relative aspect-[3/4] ${className}`} data-id="element-579" data-mp="2z432qsih433l">
      <div className="relative h-full w-full rounded-l-sm rounded-r-md bg-gradient-to-br from-navy to-navy-light shadow-[0_30px_60px_-25px_rgba(26,40,56,0.6)]" data-id="element-580" data-mp="21o75pu8x9g9p">
        <div className="absolute left-0 top-0 h-full w-[6%] rounded-l-sm bg-black/25" data-id="element-581" data-mp="26kxh449s7nos" />
        <div className="absolute right-[-4px] top-[4%] h-[92%] w-[3%] rounded-r-sm bg-paper/80" data-id="element-582" data-mp="2yndxv59d0dnm" />
        {emblem && <div className="absolute left-1/2 top-1/2 flex aspect-square w-[36%] -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full border border-seaglass-light/40" data-id="element-583" data-mp="2uoonzmnj5e8q">
            <div className="h-[45%] w-[55%] rounded-b-[10px] border-b-[3px] border-l-[3px] border-r-[3px] border-seaglass-light/80" data-id="element-584" data-mp="2kwil3hvqpcer" />
          </div>}
      </div>
    </div>;
}